<template>
    <v-card-title class="pa-1 pa-md-4">
        <h1 class="text-md-h1 primary-text-color d-flex flex-wrap justify-center">
            {{ welcomeText }}, {{ userName }} <span class="wave">👋</span>
        </h1>
    </v-card-title>
</template>

<script setup lang="ts">
import { IGreetingTitle } from '../types';

defineProps<IGreetingTitle>();
</script>
